<template>
  <div class="page">
    <b-container fluid>
      <b-row>
        <b-col cols="8" class="mx-auto">
          <b-img src="static/DubaiDIY/宠物/公司展会DIY卡-12.png" fluid />
        </b-col>
      </b-row>
      <div>
        <hr />
        <!-- Name -->
        <b-row class="rowItem">
          <b-col cols="3">
            <label for="input-name">First name</label>
          </b-col>
          <b-col cols="9">
            <b-form-input
              v-model="first_name"
              id="input-name"
              type="text"
              placeholder="input your first name"
              :state="first_nameError ? false : null"
            ></b-form-input>
            <b-form-invalid-feedback v-if="first_nameError">{{
              first_nameErrorMessage
            }}</b-form-invalid-feedback>
          </b-col>
        </b-row>
        <hr />
        <b-row class="rowItem">
          <b-col cols="3">
            <label for="input-name">Last name</label>
          </b-col>
          <b-col cols="9">
            <b-form-input
              v-model="last_name"
              id="input-name"
              type="text"
              placeholder="input your last name"
              :state="last_nameError ? false : null"
            ></b-form-input>
            <b-form-invalid-feedback v-if="last_nameError">{{
              last_nameErrorMessage
            }}</b-form-invalid-feedback>
          </b-col>
        </b-row>
        <hr />
        <!-- Phone number -->
        <b-row class="rowItem">
          <b-col cols="3">
            <label for="input-mobile">Phone number</label>
          </b-col>
          <b-col cols="9">
            <b-form-input
              v-model="mobile"
              id="input-mobile"
              type="tel"
              placeholder="input your Phone number"
              :state="mobileError ? false : null"
            ></b-form-input>
            <b-form-invalid-feedback v-if="mobileError">{{
              mobileErrorMessage
            }}</b-form-invalid-feedback>
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col cols="1">
            <b-form-checkbox
              id="checkbox-1"
              v-model="status"
              name="checkbox-1"
              value="accepted"
              unchecked-value="not_accepted"
            />
          </b-col>
          <b-col>
            <font
              >I have read and agree to abide by the "DIY Making card".</font
            >
          </b-col>
        </b-row>
      </div>
      <!-- Next step -->
      <b-row class="rowBtn">
        <b-col cols="10" class="mx-auto">
          <b-button
            block
            variant="danger"
            @click="commit()"
            :disabled="disabled"
            >Next step</b-button
          >
        </b-col>
      </b-row>
      <b-modal
        ref="model_bank_confirm"
        title="Tips"
        ok-title="Ok"
        cancel-title="Cancel"
      >
        <p>Please fill in your name and phone number</p>
      </b-modal>
    </b-container>
  </div>
</template>
<script>
export default {
  name: "ApplyCard_Dubai",
  data() {
    return {
      first_name: "",
      last_name: "",
      name: "", //Name
      mobile: "", //Phone number
      loading: false,
      // 办卡类型
      stats: "",
      status: "not_accepted",
      disabled: true,
      first_nameError: false,
      first_nameErrorMessage: "Please fill in your English name",
      last_nameError: false,
      last_nameErrorMessage: "Please fill in your English name",
      mobileError: false,
      mobileErrorMessage: "Please enter the correct phone number",
    };
  },
  watch: {
    first_name(newVal, oldval) {
      this.validateFirst_name(newVal);
    },
    last_name(newVal, oldval) {
      this.validateLast_name(newVal);
    },
    mobile(newVal, oldval) {
      this.validateMobile(newVal);
    },
    status: function (newval, oldval) {
      console.log("newval：" + newval, "oldval：" + oldval);
      if (newval == "accepted") {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
    },
  },
  mounted: function () {
    this.stats = this.$route.params.stats;
    console.log("stats--->", this.stats);
    let stats_tag = this.stats;
    if (stats_tag !== undefined) {
      sessionStorage.setItem("stats_tag", stats_tag);
    } else {
      stats_tag = sessionStorage.getItem("stats_tag");
    }
    this.stats = stats_tag;
  },
  methods: {
    validateFirst_name(first_name) {
      // 使用正则表达式验证手机号码
      const Regex = /^[a-zA-Z]+$/;
      if (!Regex.test(first_name)) {
        this.first_nameError = true;
      } else {
        this.first_nameError = false;
      }
    },
    validateLast_name(last_name) {
      // 使用正则表达式验证手机号码
      const Regex = /^[a-zA-Z]+$/;
      if (!Regex.test(last_name)) {
        this.last_nameError = true;
      } else {
        this.last_nameError = false;
      }
    },
    validateMobile(mobile) {
      // 使用正则表达式验证手机号码
      const phoneRegex = /^1[3-9]\d{9}$/;
      if (!phoneRegex.test(mobile)) {
        this.mobileError = true;
      } else {
        this.mobileError = false;
      }
    },
    commit() {
      if (this.first_nameError == true) {
        return;
      }
      if (this.last_nameError == true) {
        return;
      }
      if (this.mobileError == true) {
        return;
      }
      this.commitUserInfo();
    },
    commitUserInfo() {
      if (this.first_name == "" || this.first_name == "" || this.mobile == "") {
        this.showBankConfirm();
      } else {
        this.name = `${this.first_name} ${this.last_name}`;
        if (this.stats == "DIY") {
          this.toSelectCardFace();
        } else if (this.stats == "SElE_DIY") {
          this.toSelect_card();
        }
      }
    },
    toSelectCardFace() {
      this.$router.push({
        name: "SelectCardface_Dubai",
        query: {
          name: this.name,
          mobile: this.mobile,
        },
      });
    },
    toSelect_card() {
      this.$router.push({
        name: "select_card",
        query: {
          name: this.name,
          mobile: this.mobile,
        },
      });
    },
    showBankConfirm: function () {
      this.$refs["model_bank_confirm"].show();
    },
    showLoading: function () {
      this.loading = true;
    },
    hideLoading: function () {
      this.loading = false;
    },
  },
};
</script>
<style scoped>
.rowItem {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.rowItemFee {
  margin-top: 1rem;
}

.rowBtn {
  margin-top: 3rem;
  margin-bottom: 3rem;
}

.page {
  margin-top: 4vh;
}

.img {
  width: 100%;
}

.innerText {
  text-indent: 2rem;
}

.itemWordWrap {
  word-wrap: break-word;
}
</style>



// WEBPACK FOOTER //
// src/components/DubaiCard/ApplyCard_Dubai.vue